import { useRecoilValue } from 'recoil';

import { useGetAdminUsers } from 'api';
import { manageUsersSearchState } from 'store';
import { ApplicationUser } from 'types';

export type useGetAdminUsersRecordsReturn = {
  userData: ApplicationUser[];
  totalCount: number;
};

export const useGetAdminUsersRecords = (): useGetAdminUsersRecordsReturn => {
  const { data: ApplicationUsers } = useGetAdminUsers();
  const searchText = useRecoilValue(manageUsersSearchState);
  const users = ApplicationUsers?.adminUsers ?? [];
  const totalCount = users.length;

  const userData = users.filter(
    (r: { name: string; email: string }) =>
      !searchText ||
      r.name.toLowerCase().includes(searchText.toLowerCase()) ||
      r.email.toLowerCase().includes(searchText.toLowerCase())
  );

  return {
    userData,
    totalCount,
  };
};
